import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_AUDIT_PAGE_SIZE,
  buildAdminAuditRequest,
  buildAuditActionRequest,
  buildAuditActorRequest,
  buildAuditBrowseRequest,
  buildAuditTargetTypeRequest,
  isReversedAuditDateRange,
} from './auditListRequest';

export {
  ADMIN_AUDIT_PAGE_SIZE,
  buildAdminAuditRequest,
  buildAuditActionRequest,
  buildAuditActorRequest,
  buildAuditBrowseRequest,
  buildAuditTargetTypeRequest,
  isReversedAuditDateRange,
};

/**
 * Admin audit log. Callables only — no client Firestore reads of adminAuditLogs.
 * @param {{
 *   pageSize?: number,
 *   pageToken?: string,
 *   action?: string,
 *   actorUid?: string,
 *   targetType?: string,
 *   createdAfter?: string,
 *   createdBefore?: string,
 * }} request
 */
export async function listAdminAuditLogs(request) {
  const fn = httpsCallable(functions, 'listAdminAuditLogs');
  const { data } = await fn(request);
  return data;
}
